import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  azure1,
  grey10,
  grey3,
  grey4,
  grey8,
  grey9,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  spacing4,
  spacing8,
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  font12,
  font14,
  fontWeightBold,
  fontWeightMedium,
  PStyled,
} from 'approot/shared/styles/typography.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';

export const TeachingNotesSummaryHeader = styled.div`
  display: flex;
  height: ${rem(168)};
  background-color: ${azure1};
  padding: ${rem(spacing12)};

  img {
    width: ${rem(120)};
  }
`;

export const TeachingNotesSummaryHeading = styled.div`
  ${font14}
  color: ${purple7};
  font-weight: ${fontWeightBold};
  margin-top: ${rem(44)};
  margin-left: ${rem(spacing8)};
`;

export const TeachingNotesSummaryButton = styled.button`
  ${SecondaryBaseStyled}
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${rem(70)};
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing8)} ${rem(spacing16)};
  margin-bottom: ${rem(spacing16)};

  & > svg {
    fill: ${grey10};
    stroke: none;
    transform: rotate(-90deg);
  }
`;

export const TeachingNotesSummaryQuestionDetails = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const TeachingNotesSummaryText = styled(PStyled)`
  color: ${grey9};
  margin: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TeachingNotesSummaryFooter = styled.div`
  display: flex;
  align-items: center;
  height: ${rem(75)};
  width: 100%;
  border-top: 1px solid ${grey4};
  padding: ${rem(spacing24)};
  color: ${grey8};

  svg {
    fill: ${grey8};
    margin-right: ${rem(spacing16)};
  }

  span {
    color: ${grey9};
    font-weight: ${fontWeightMedium};
    margin-left: ${rem(spacing16)};
  }
`;

export const TeachingNotesSummaryPill = styled.div`
  ${font12}

  display: flex;
  align-items: center;
  margin-right: ${rem(spacing4)};
  height: ${rem(24)};
  border-radius: ${rem(48)};
  padding: ${rem(2)} ${rem(spacing8)};
  background-color: ${grey3};
  flex-shrink: 1;
  flex-grow: 0;
  overflow: hidden;

  span {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  svg {
    margin-left: ${rem(spacing4)};
    stroke: none;
  }
`;

export const TeachingNotesSummaryPillWrapper = styled.div`
  display: flex;
`;

export const TeachingNotesSummaryOverflow = styled.div`
  width: 100%;
  overflow: hidden;
`;
